import React from 'react'
import ProgressBar from './progressBar'
import sectionStyles from '../../styles/tracker-modules/distribution.module.less'

import { dataLabels } from './vaccine-component-helpers/dataLabels'

import DataTable from './dataTable'
import { formatTimestamp } from '../sfc/component-helpers/datehelpers'

// columns in order they will show
const useKeys = ['n', 'd', 'a', 'pd']

function DistributionSection({
  allUSData,
  activeStateObj,
  modDate,
  marketKey,
}) {
  function onSortTable(sortColumn) {
    if (typeof window.ens_specialEvent !== 'undefined') {
      window.ens_specialEvent(
        `Vaccine Tracker ${marketKey}`,
        `Distribution table sort`,
        `${sortColumn}`
      )
    }
    // } else {
    //   console.log(
    //     'would send GA event',
    //     `Vaccine Tracker ${marketKey}`,
    //     `Distribution table sort`,
    //     `${sortColumn}`
    //   )
    // }
  }

  function onToggleTable(btnText) {
    if (typeof window.ens_specialEvent !== 'undefined') {
      window.ens_specialEvent(
        `Vaccine Tracker ${marketKey}`,
        `Distribution table ${btnText}`
      )
    }
    // } else {
    //   console.log(
    //     'would send GA event',
    //     `Vaccine Tracker ${marketKey}`,
    //     `Distribution table ${btnText}`
    //   )
    // }
  }

  return (
    <section>
      {allUSData && activeStateObj && (
        <div className="container">
          <div className={sectionStyles.header}>
            <h3 className="subhed">
              About{' '}
              {activeStateObj.pd.toLocaleString('en-US', { style: 'percent' })}{' '}
              of vaccine doses shipped to {activeStateObj.n} have been
              administered
            </h3>
            <p id="bar-label-ship">
              National distributors have shipped{' '}
              {activeStateObj.d.toLocaleString()} vaccine doses to{' '}
              {activeStateObj.n}. The state has administered{' '}
              {activeStateObj.a.toLocaleString()} of those doses to people.
            </p>
            <ProgressBar
              data={[{ barStyle: 'pd', val: activeStateObj.pd }]}
              val={activeStateObj.pd}
              total={activeStateObj.d}
              label="shipped doses"
              labeledById="bar-label-ship"
            />
          </div>

          <div className={sectionStyles.tableContainer}>
            <DataTable
              data={allUSData}
              rowHeaderKey="n"
              dataLabels={dataLabels}
              maxLength={5}
              highlightRow={activeStateObj.n}
              sortable={true}
              useKeys={useKeys}
              stickyRowHeader={true}
              gaSortEvent={onSortTable}
              gaToggleEvent={onToggleTable}
            />
          </div>
        </div>
      )}
      <p className="footnote container">
        Last updated: {formatTimestamp(modDate)} <br />
        Source: CDC
      </p>
    </section>
  )
}

export default React.memo(DistributionSection)
